<template>
  <div class="dashboard-header">
    <h1 class="dashboard-title">
      {{ title }}
    </h1>

    <LastUpdated :last-updated="lastUpdated" />
  </div>
</template>

<script>
import LastUpdated from "@/components/standard/footer/LastUpdated";

const components = {
  LastUpdated,
};

const props = {
  lastUpdated: {
    required: true,
    type: String,
  },
  title: {
    default: "Dashboard Title Missing",
    required: true,
    type: String,
  },
};

export default {
  components,
  props,
};
</script>

<style scoped>
.dashboard-header {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  margin-top: 1em;
  width: 100%;
}

.dashboard-title {
  font-size: 1.5em;
  font-weight: 600;
}
</style>
